"use client";

import React from "react";
import { Target, MessageSquare, Briefcase, Network } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const segments = [{
  title: "Gestão Omnichannel",
  description: "Unifique canais físicos e digitais em uma única interface. Controle pedidos, estoque e devoluções com rastreabilidade total em tempo real para operações complexas.",
  icon: Target
}, {
  title: "Automação Fiscal",
  description: "Elimine gargalos tributários com um sistema preparado para as legislações brasileiras. Emissão de documentos e conciliação automática para total conformidade.",
  icon: MessageSquare
}, {
  title: "Inteligência Logística",
  description: "Otimize o WMS e a expedição de grandes centros de distribuição. Reduza custos operacionais e aumente a velocidade de entrega com fluxos de trabalho inteligentes.",
  icon: Briefcase
}];
export default function UserSegments() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="157531" id="efficiencyandcontrol" className="bg-background py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col gap-16">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-3xl mx-auto gap-6 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center p-3 bg-primary/20 rounded-full mb-2 backdrop-blur-md border border-primary/30">
            <Network className="size-6 text-primary" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight">
            Controle e Eficiência para Operações de Alta Performance
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            O e-Millennium é a central de comando definitiva da LinxConsult para gerenciar atacado, indústria e varejo digital com governança absoluta.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-200 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {segments.map((segment, i) => <div data-index={i} key={i} className="h-full">
              <Card className="h-full rounded-[12px] border-white/10 shadow-xl hover:shadow-primary/5 transition-all duration-300 bg-card/40 backdrop-blur-xl group">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-xl bg-background border border-white/5 flex items-center justify-center mb-4 group-hover:border-primary/50 group-hover:bg-primary/10 transition-colors duration-300">
                    <segment.icon className="size-6 text-primary" />
                  </div>
                  <CardTitle className="text-2xl text-foreground font-semibold">
                    {segment.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {segment.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div ref={footerRef} className={`max-w-4xl mx-auto text-center mt-8 transition-all duration-1000 delay-400 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="p-8 md:p-12 rounded-[12px] bg-card/30 border border-white/10 shadow-2xl relative overflow-hidden backdrop-blur-md">
            {}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
            
            <p className="text-xl md:text-2xl text-foreground font-medium leading-relaxed">Com a consultoria especialista da Linx Vila Velha, sua transição para o&nbsp; &nbsp; &nbsp; &nbsp; e-Millennium garante uma arquitetura de marca coesa e uma execução de alta qualidade, do estoque ao checkout.</p>
          </div>
        </div>
      </div>
    </section>;
}